import React from "react";
import { Sidebar, Menu, SubMenu, MenuItem } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import SVG from "react-inlinesvg";
import { MdShareLocation } from "react-icons/md";
import Home from "../../assets/images/icons/home.svg";
import Vehicles from "../../assets/images/icons/vehicles.svg";
import Reports from "../../assets/images/icons/reports.svg";
import Plans from "../../assets/images/icons/plans.svg";
import Faqs from "../../assets/images/icons/faqs.svg";
import Support from "../../assets/images/icons/support.svg";
// companies load start
import Dashboard from "../../assets/images/companies/load_dashboard.svg";
import LoadSvg from "../../assets/images/companies/loads.svg";
import TripSvg from "../../assets/images/companies/trips.svg";
import SupportSvg from "../../assets/images/companies/load_support.svg";
import NotificationSvg from "../../assets/images/companies/notifications.svg";
// companies load end
import Translate from "../../components/Translate";
import { IoBagCheckOutline } from "react-icons/io5";
import { BsFuelPump } from "react-icons/bs";
import { FiAlertTriangle } from "react-icons/fi";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { BsCalculator } from "react-icons/bs";
import { GiTyre } from "react-icons/gi";
import TMSMenu from "../TMSMenu";

const Header = ({
  userType,
  userData,
  isFuel,
  isSidebar,
  collapsed,
  closeSidebar,
  newClasss,
}) => {
  const location = useLocation();
  const isAllowedUser = userData?.id === "655b0fa8d4616f050d60027b";
  // const [width, setWidth] = useState("");
  // const [className, setClassName] = useState("sidebar");
  // const callback = (state) => state;
  // const states = useSelector(callback);
  // const access = ["Dashboard","User","Vehicles","FleetReports","PricingPlan"];
  // const accessedRoutes = CompanyRoutesConfig.filter(route =>access.includes(route.name));
  return (
    <div className={newClasss}>
      <div className="sidebar-container w-100">
        {isSidebar && (
          <Sidebar
            collapsed={collapsed}
            backgroundColor="#ffffff"
            rootStyles={{
              overflowY: "visible",
              position: "fixed",
              height: "100vh",
              top: 0,
              width: "200px",
              minWidth: "200px",
              maxWidth: "200px",
              flex: "0 0 200px",
              marginTop: "60px",
              transition: "width 0.4s ease-in-out",
            }}
          >
            {userType === "fleetOwner" && (
              <Menu>
                <MenuItem
                  active={location.pathname === "/dashboard"}
                  component={<Link to="/dashboard" />}
                  icon={<SVG src={Home} width={"25px"} height={"25px"} />}
                  onClick={closeSidebar}
                >
                  <Translate>dashboard</Translate>
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/vehicles"}
                  component={<Link to="vehicles" />}
                  icon={<SVG src={Vehicles} width={"25px"} height={"25px"} />}
                  onClick={closeSidebar}
                >
                  <Translate>myVehicles</Translate>
                </MenuItem>
                {isFuel && (
                  <MenuItem
                    className="fuel-pump"
                    active={location.pathname === "/fuel-theft"}
                    component={<Link to="/fuel-theft" />}
                    icon={<BsFuelPump size="22px" color="#626C70" />}
                    onClick={closeSidebar}
                  >
                    <Translate>fuelanalytics</Translate>
                  </MenuItem>
                )}
                <MenuItem
                  className="fuel-pump"
                  active={location.pathname === "/geofence"}
                  component={<Link to="/geofence" />}
                  icon={<MdShareLocation size="25px" />}
                  onClick={closeSidebar}
                >
                  <Translate>geofence</Translate>
                </MenuItem>
                {isAllowedUser && (
                  <MenuItem
                    className="fuel-pump"
                    active={location.pathname === "/tyre-management"}
                    component={<Link to="/tyre-management" />}
                    icon={<GiTyre size="25px" />}
                    onClick={closeSidebar}
                  >
                    <Translate>Tyre Management</Translate>
                  </MenuItem>
                )}
                <MenuItem
                  active={location.pathname === "/fleet-reports"}
                  component={<Link to="/fleet-reports" />}
                  icon={<SVG src={Reports} width={"25px"} height={"25px"} />}
                  onClick={closeSidebar}
                >
                  <Translate>fleetReport</Translate>
                </MenuItem>
                <MenuItem
                  className="fuel-pump"
                  active={location.pathname === "/Alerts"}
                  component={<Link to="/Alerts" />}
                  icon={<FiAlertTriangle size="25px" />}
                  onClick={closeSidebar}
                >
                  <Translate>Alerts</Translate>
                </MenuItem>
                {isAllowedUser && <TMSMenu />}
                <SubMenu
                  label={<Translate>pricingPlans</Translate>}
                  icon={<SVG src={Plans} width={"25px"} height={"25px"} />}
                  className="sub-menu"
                  expandicon={<BsFuelPump />}
                >
                  <MenuItem
                    label={<Translate>buyNewGPS</Translate>}
                    active={location.pathname === "/plans/buy-gps"}
                    // icon={<SVG src={gpsPlan} width={"25px"} height={"25px"} />}
                    component={<Link to="/plans/buy-gps" />}
                    onClick={closeSidebar}
                  >
                    <Translate>buyNewGPS</Translate>
                  </MenuItem>
                  <MenuItem
                    className="fuel-pump"
                    label={<Translate>buyNewFuelSensorGPS</Translate>}
                    active={location.pathname === "/plans/buy-gps-fuel"}
                    // icon={<BsFuelPump size="22px" color="#626C70" />}
                    component={<Link to="/plans/buy-gps-fuel" />}
                    onClick={closeSidebar}
                  >
                    <Translate>buyNewFuelSensorGPS</Translate>
                  </MenuItem>
                </SubMenu>
                <MenuItem
                  className="desktop-view"
                  active={location.pathname === "/documents"}
                  component={<Link to="/documents" />}
                  icon={
                    <MdOutlineDocumentScanner size="22px" color="#626C70" />
                  }
                  onClick={closeSidebar}
                >
                  <Translate>documents</Translate>
                </MenuItem>
                <MenuItem
                  className="fuel-pump"
                  active={location.pathname === "/trip-calculator"}
                  component={<Link to="/trip-calculator" />}
                  icon={<BsCalculator size="20px" color="#626C70" />}
                  onClick={closeSidebar}
                >
                  <Translate>tripCalculator</Translate>
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/orders"}
                  component={<Link to="/orders" />}
                  icon={<IoBagCheckOutline size="22px" color="#626C70" />}
                  onClick={closeSidebar}
                >
                  <Translate>myOrders</Translate>
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/faqs"}
                  component={<Link to="/faqs" />}
                  icon={<SVG src={Faqs} width={"25px"} height={"25px"} />}
                  onClick={closeSidebar}
                >
                  <Translate>faqs</Translate>
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/support"}
                  component={<Link to="/support" />}
                  icon={<SVG src={Support} width={"25px"} height={"25px"} />}
                  onClick={closeSidebar}
                >
                  <Translate>support</Translate>
                </MenuItem>
              </Menu>
            )}
            {userType === "company" && (
              <Menu>
                <MenuItem
                  active={location.pathname === "/company/dashboard"}
                  component={<Link to="/company/dashboard" />}
                  icon={<SVG src={Dashboard} width={"20px"} height={"20px"} />}
                  onClick={closeSidebar}
                >
                  Dashboard
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/company/loads"}
                  component={<Link to="/company/loads" />}
                  icon={<SVG src={LoadSvg} width={"20px"} height={"20px"} />}
                  onClick={closeSidebar}
                >
                  Loads
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/company/trips"}
                  component={<Link to="/company/trips" />}
                  icon={<SVG src={TripSvg} width={"20px"} height={"20px"} />}
                  onClick={closeSidebar}
                >
                  Trips
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/company/notifications"}
                  component={<Link to="/company/notifications" />}
                  icon={
                    <SVG src={NotificationSvg} width={"20px"} height={"20px"} />
                  }
                  onClick={closeSidebar}
                >
                  Notifications
                </MenuItem>
                <MenuItem
                  active={location.pathname === "/company/support"}
                  component={<Link to="/company/support" />}
                  icon={<SVG src={SupportSvg} width={"20px"} height={"20px"} />}
                  onClick={closeSidebar}
                >
                  Support
                </MenuItem>
              </Menu>
            )}
          </Sidebar>
        )}
      </div>
    </div>
  );
};
export default Header;
